module.exports = __webpack_public_path__ + "assets/img/f3c9-au.svg";